import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#IM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#IM_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.094 4.141c-.008-.092.103-.137.165-.069.45.492 1.636 1.716 2.323 1.716.859 0 4.232-2.843 5.23-2.38.997.464 3.016 5.305 3.016 5.305l-1.316 1.65-1.7-.927-.322-3.648S10.217 7.471 8.582 6.86l-.92.773S6.778 5.88 6.43 5.343c-.231-.354-.309-.884-.335-1.202z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.263 8.125l-.56.339.107-.718-.453-.51.626-.104.28-.653.28.653.626.105-.453.509.107.718-.56-.34zM13.014 3.792a.363.363 0 01.725 0v1.714a.363.363 0 01-.725 0V3.792z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.22 5.103c.083.042.063.16-.029.177-.655.12-2.322.478-2.685 1.06-.456.729.167 5.096-.754 5.697-.92.6-6.097-.254-6.097-.254l-.702-1.99 1.688-.95 3.264 1.66s.306-3.668 1.691-4.73l-.168-1.19s1.956.178 2.595.167c.424-.008.914.207 1.198.353z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.693 4.832l.009-.655.552.472.672-.115-.243.586.406.584-.702-.109-.421.475-.192-.653-.665-.29.584-.295zM21.914 11.204a.392.392 0 11-.424.66l-1.549-1.035a.36.36 0 01.39-.606l1.583.981z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.861 20.984c-.078.05-.17-.026-.138-.114.223-.627.747-2.25.424-2.856-.403-.758-4.497-2.402-4.556-3.5-.06-1.098 3.268-5.154 3.268-5.154l2.075.387-.021 1.937-3.07 1.996s3.023 2.1 3.251 3.83l1.114.45s-1.132 1.604-1.442 2.164c-.205.37-.636.688-.905.86z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.362 17.2l.562.335-.684.243-.237.638-.386-.503-.709.06.446-.554-.201-.602.662.16.584-.43-.037.653zM11.104 14.958a.406.406 0 01-.293-.759l1.668-.65a.413.413 0 11.298.77l-1.673.639z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.663 9.766a.245.245 0 01-.148-.31c.042-.127.242-.34.366-.297l1.736.607c.09.03.152.114.16.21l.155 1.904c.011.134-.184.243-.315.254a.24.24 0 01-.257-.223l-.144-1.637-1.553-.508z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.68 8.768c.104-.083.289.013.37.119.08.106.062.26-.042.342l-1.202 1.233c-.104.082-.337-.079-.418-.185-.081-.106-.104-.396 0-.479l1.292-1.03z",
      fill: "#FECA00"
    }
  )))
);
export {
  t as default
};
